import EventEmitter from 'eventemitter3'

export const requestAccessEvent = new EventEmitter()

export function showRequestAccessModal() {
    requestAccessEvent.emit('REQUESTACCESS-MODAL')
}

export function stopRequestAccessModal() {
    requestAccessEvent.emit('REQUESTACCESS-MODAL')
}

export function removeRequestAccessModal() {
    requestAccessEvent.removeListener('REQUESTACCESS-MODAL')
}
